import React, { useEffect, useState } from 'react';

import styles from './MostLiked.module.css';

const btnStyles = ['mlBtn', 'mlBtnActive'];

// const tempData = {
//   "tags": [
//       "abstract"
//   ],
//   "media": [
//       "pencil"
//   ],
//   "_id": "619fd0a40b7b875b70bce537",
//   "date": "Thu Nov 25 2021 10:06:25 GMT-0800 (PST)",
//   "image": "abstract_69069cc0-4e1a-11ec-89b5-61bf1caa85f0.jpeg",
//   "likes": 10,
//   "__v": 3,
//   "id": "619fd0a40b7b875b70bce537"
// }

const transformDate = (date) => {
  return new Date(date).toLocaleString();
};

const MostLiked = (props) => {
  const [mlMode, setMlMode] = useState('0');
  const [topCats, setTopCats] = useState();
  const [topMedias, setTopMedias] = useState();

  const [mostLikedStickies, setMostLikedStickies] = useState({
    date: new Date().toString(),
    image: 'blank.jpeg',
    tags: ['loading...'],
    media: ['loading...']
  });
  // const [dataGotten, setDataGotten] = useState(false);

  useEffect(() => {
    if (props.mostLikedArray) {
      // console.log('got something!');
      // const newP = `${props.mostLikedArray.tags.join(", ")} w/ ${props.mostLikedArray.media.join(", ")} - ${props.mostLikedArray.likes} likes`;
      setMostLikedStickies((prev) => props.mostLikedArray);
    } else {
      // console.log('got nothing.');
    }
  }, [props.mostLikedArray]);

  useEffect(() => {
    if (props.catArray.length > 0 && props.mediaArray.length > 0) {
      setTopCats((prev) => props.catArray);
      setTopMedias((prev) => props.mediaArray);
      console.log('TOPCATS', topCats)
      console.log('TOPMEDIAS', topMedias)
    } else {
      // console.log('got nothing.');
    }
  }, [props.catArray, props.mediaArray, topCats, topMedias]);

  // useEffect(() => {
  //   console.log(loadedStickies);
  //   // const lastSticky = loadedStickies[12];
  //   // setMostRecentSticky(lastSticky);
  // }, [loadedStickies]);

  // console.log(latestSticky);

  const modeHandler = (e) => {
    const id = e.target.id;
    // console.log(id);
    if (e.target.id !== '') {
          setMlMode(id);
    } else {
      return;
    }
    // console.log(mlMode);
  };

  return (
    <div className={styles.mostLikedContainer}>
      <h2>most liked:</h2>
      <div className={styles.likedDiv}>
        {mlMode === '0' && (
          <div>
            <div className={styles.stickyDiv}>
              <div className={styles.sticky}>
                <img
                  src={`https://no2.dev/stickynotes/api/uploads/stickies/${mostLikedStickies.image}`}
                  alt={`${mostLikedStickies.tags[0]}-related drawing.`}
                />
              </div>
            </div>
            <div className={styles.labelDiv}>
              <div className={styles.label}>
                {/* <p>{transformDate(mostLikedStickies.date)}</p> */}
                <p>{mostLikedStickies.tags[0]}</p>
                <p>in</p>
                <p>{mostLikedStickies.media.join(', ')}</p>
                {/* <p>{mostLikedStickies}</p> */}
                <p>-</p>
                <p>{mostLikedStickies.likes} likes</p>
              </div>
            </div>
          </div>
        )}
        {mlMode === '1' && (
          <div className={styles.mlCatDiv}>
            <p className={styles.mlCat}>
            <span>{`${topCats[0].category} - ${topCats[0].likes} likes`}</span><br />
            {`${topCats[1].category}: ${topCats[1].likes} likes`}<br />
            {`${topCats[2].category}: ${topCats[2].likes} likes`}<br />
            {`${topCats[3].category}: ${topCats[3].likes} likes`}<br />
            {`${topCats[4].category}: ${topCats[4].likes} likes`}<br />
            </p>
          </div>
        )}
        {mlMode === '2' && (
          <div className={styles.mlCatDiv}>
            <p className={styles.mlCat}>
            <span>{`${topMedias[0].media} - ${topMedias[0].likes} likes`}</span><br />
            {`${topMedias[1].media}: ${topMedias[1].likes} likes`}<br />
            {`${topMedias[2].media}: ${topMedias[2].likes} likes`}<br />
            {`${topMedias[3].media}: ${topMedias[3].likes} likes`}<br />
            {`${topMedias[4].media}: ${topMedias[4].likes} likes`}<br />
            </p>
          </div>
        )}
      </div>
      <div className={styles.mlBtnGroup} onClick={modeHandler}>
        <button
          id={'0'}
          className={mlMode === '0' ? styles.mlBtnActive : styles.mlBtn}
        >
          Sticky Note
        </button>
        <button
          id={'1'}
          className={mlMode === '1' ? styles.mlBtnActive : styles.mlBtn}
        >
          Categories
        </button>
        <button
          id={'2'}
          className={mlMode === '2' ? styles.mlBtnActive : styles.mlBtn}
        >
          Media
        </button>
      </div>
    </div>
  );
};

export default MostLiked;
